import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  ChurnFlowAnalyticsBaseService,
  ChurnFlowDataBaseService,
  ChurnFlowNavigationBaseService,
} from '@core/churn-flow-logic';
import { ChurnFlowTestimonial, ChurnReason } from '@core/churn-flow-types';
import { ChurnFlowStepTemplateComponent, ChurnFlowTestimonialComponent } from '@core/churn-flow-ui';
import { filterDefined } from '@core/common-legacy';
import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

@Component({
  selector: 'tlc-churn-farewell-page',
  templateUrl: './churn-farewell-page.component.html',
  styleUrls: ['./churn-farewell-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChurnFlowStepTemplateComponent,
    ChurnFlowTestimonialComponent,
    IconComponent,
    TranslatePipe,
    ButtonComponent,
  ],
})
export class ChurnFarewellPageComponent {
  private readonly t = injectTranslate();
  private readonly analytics = inject(ChurnFlowAnalyticsBaseService);
  private readonly untilDestroyed = injectUntilDestroyed();
  private readonly churnFlowDataService = inject(ChurnFlowDataBaseService);
  private readonly churnFlowNavigationService = inject(ChurnFlowNavigationBaseService);

  public readonly willSubscriptionRenewOnce = this.churnFlowDataService.willSubscriptionRenewOnce;
  public readonly cancellationDates = this.churnFlowDataService.subscriptionCancellationDates;

  public testimonial: ChurnFlowTestimonial = {
    text: this.t('tlc.churn_flow.steps.farewell.testimonial.text'),
    avatarSrc: 'assets/images/churn-flow/ceo-profile.png',
    name: this.t('tlc.churn_flow.steps.farewell.testimonial.name'),
    role: this.t('tlc.churn_flow.steps.farewell.testimonial.role'),
  };

  public backToBilling(): void {
    this.churnFlowDataService.lockedChurnReason
      .pipe(filterDefined, this.untilDestroyed)
      .subscribe((reason: ChurnReason) => {
        this.analytics.trackFarewellStepContinue({ reason });
        this.churnFlowNavigationService.navigateToBilling();
      });
  }
}
